'use client'
import React, { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'

import { RANKINGS } from '@/graphql/globalwidget/rankings.query'
import { allRoutes } from '@/shared/constants/allRoutes'
import CustomLink from '@/shared/components/customLink'
import CommonNav from '../../commonNav'
import { getMatchFormat, getSlugUrl } from '@/shared/utils'

const RankingTab = () => {
	const [filter, setFilter] = useState({ eMatchType: 'Tests', eRankType: 'Teams', nLimit: 5, nSkip: 0 })
	const [rankings, setRankings] = useState([])

	const [getRankings, { loading }] = useLazyQuery(RANKINGS, {
		onCompleted: (newData) => {
			setRankings(newData?.getRankings?.aResults)
		},
	})

	const handleRankFilter = ({ value }: any) => {
		setFilter({ ...filter, eRankType: value })
		getRankings({ variables: { input: { ...filter, eRankType: value } } })
	}
	const handleMatchFilter = ({ value }: any) => {
		setFilter({ ...filter, eMatchType: value })
		getRankings({ variables: { input: { ...filter, eMatchType: value } } })
	}

	useEffect(() => {
		getRankings({ variables: { input: { ...filter } } })
	}, [])

	const rankType = [
		{ navItem: 'Teams', value: 'Teams' },
		{ navItem: 'Batting', value: 'Batsmen' },
		{ navItem: 'Bowling', value: 'Bowlers' },
		{ navItem: 'ALR', value: 'AllRounders' },
	]
	const matchType = [
		{ navItem: getMatchFormat('test'), value: 'Tests' },
		{ navItem: getMatchFormat('odi'), value: 'Odis' },
		{ navItem: getMatchFormat('t20i'), value: 'T20s' },
	]
	return (
		<div className='w-full'>
			<div className={`flex justify-between items-center mb-4 mt-3`}>
				<h3 className='font-bold text-lg mb-0 text-textOffWhite flex items-center justify-center md:justify-start'>
					<span>Ranking</span>
				</h3>
				<CustomLink
					href={allRoutes.iccRankings as string}
					className='font-medium text-sm text-primary-500 transition-colors'>
					View All
				</CustomLink>
			</div>
			<div className=''>
				<CommonNav
					items={matchType}
					variant='pills'
					asButton
					className='mb-3 dark:px-0 !font-bold'
					tabClassName='!text-xs !font-bold'
					onTabChange={handleMatchFilter}
					isActive={(item) => item?.value === filter.eMatchType}
				/>
				<CommonNav
					items={rankType}
					tabClassName='col-span-3 items-center overflow-visible  text-center !px-0 w-full !text-sm !font-bold hover:border-b-transparent'
					className='grid grid-cols-12 gap-x-2 overflow-visible !px-3'
					activeTabClass=''
					variant='underlined'
					asButton
					onTabChange={handleRankFilter}
					isActive={(item) => item?.value === filter.eRankType}
				/>

				<div>
					<div className={`flex text-sm items-center w-full px-3 py-2 text-center`}>
						<p className='w-10'>Rank</p>
						<p className='w-11 px-3 flex-grow text-left'>{filter.eRankType !== 'Teams' ? 'Player' : 'Team'}</p>
						<p className='w-11'>Rating</p>
					</div>
					{!loading && rankings?.length === 0 && (
						<div>
							<p className='mb-0 w-full text-center text-t-700 py-3'>No Data Found</p>
						</div>
					)}
					<div className='w-full px-3 text-sm'>
						{rankings?.map((element: any) => {
							return (
								<div
									key={element._id}
									className={`flex items-center text-t-700 py-3 border-t border-t-c`}>
									<p className='mb-0 w-10 text-center'>{element.nRank}</p>
									<p className='mb-0 w-11 px-3 flex-grow text-left whitespace-nowrap text-ellipsis'>
										{element?.oPlayer?.eTagStatus === 'a' && element?.oPlayer?.oSeo?.eStatus === 'a' && element?.oPlayer?.oSeo?.sSlug ? (
											<CustomLink
												className='text-t-700'
												href={getSlugUrl(`/${element?.oPlayer?.oSeo?.sSlug}`)}>
												{element.sName}
											</CustomLink>
										)  : filter?.eRankType === 'Teams' && element?.oTeams?.oSeo?.sSlug ? ( 
											<>
											<CustomLink
												className='text-t-700'
												href={getSlugUrl(`/${element?.oTeams?.oSeo?.sSlug}`)}>
												{element.sName}
											</CustomLink>
											</>
										) : (
											<span className='text-t-700'>{element.sName}</span>
										)}
									</p>
									<p className='mb-0  w-11 text-center'>{element.nRating}</p>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		</div>
	)
}

export default RankingTab
